import { AuthenticationService } from './../../../../../../services/authentication/authentication.service';
import { RoleService } from 'app/main/services/roles/role.service';
import { Role } from 'app/main/models/roles/role';
import { TranslationService } from 'app/main/services/translation/translation.service';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { fuseAnimations } from 'app/core/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import {FormControl, Validators, FormBuilder, FormArray} from '@angular/forms';
import { UserService } from 'app/main/services/users/user.service';
import { SweetAlertService } from 'app/main/services/sweet-alert/sweet-alert.service';
import { CustomValidators } from 'app/main/helpers/custom-validators.helper';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import * as moment from 'moment';
import { ImageService } from 'app/main/services/images/image.service';
import { environment } from '../../../../../../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {ShiftService} from '../../../../../../services/shifts/shift.service';
import {Shift} from '../../../../../../models/shifts/shift';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const PASSWORD_REGEX = /^(?=.*[a-zñ])(?=.*[A-ZÑ])(?=.*\d)(?=.*[$@$#%_-])([A-ZÑa-zñ\d$@$#%_-]|[^'\"°|¬!&/()=?¡¿¨*+~{}`^\[\] ]){6,20}$/;

@Component({
    selector: 'fuse-edit-or-view-user',
    templateUrl: './edit-or-view-user.component.html',
    styleUrls: ['./edit-or-view-user.component.scss'],
    animations: fuseAnimations
})
export class FuseEditOrViewUserComponent implements OnInit, AfterViewInit {

    @BlockUI('ea-photo-profile') blockUI: NgBlockUI;

    emailFormControl;
    firstNameFormControl;
    lastNameFormControl;
    applicationRoleFormControl;

    userFormGroup;

    roles: Role[];
    shifts: Shift[] = [];

    public baseUri;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseEditOrViewUserComponent>,
        private userService: UserService,
        private translationService: TranslationService,
        private roleService: RoleService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private imageService: ImageService,
        public shiftService: ShiftService
    ) {
        console.log('FuseEditOrViewUserComponent > data', data);
        this.roles = [];
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri;
    }

    ngOnInit() {
        Observable.combineLatest(
            this.roleService.getAll(),
            this.shiftService.getAll()
        ).subscribe(([ roles, shifts]) => {
            this.roles = roles;
            shifts.forEach(s => {
                const found = this.data.user.Shifts.find(e => e.Id === s.Id);
                s.Checked = !!found;
            });
            this.shifts = shifts;
        });

        this.userFormGroup.get('emailFormControl').disable();
        if (this.data.user.UserName == 'superadmin') {
            this.userFormGroup.get('applicationRoleFormControl').disable();
        }

        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    ngAfterViewInit() {

    }

    initializeFormControlValidators() {
        this.userFormGroup = this.fb.group({
            emailFormControl: ['', [Validators.required]],
            firstNameFormControl: ['', [Validators.required]],
            lastNameFormControl: ['', [Validators.required]],
            applicationRoleFormControl: ['', [Validators.required]],
        });
    }

    disable() {
        this.userFormGroup.get('firstNameFormControl').disable();
        this.userFormGroup.get('lastNameFormControl').disable();
        this.userFormGroup.get('applicationRoleFormControl').disable();
    }

    checkValidationErrors() {
    }

    save() {
        console.log('FuseEditOrViewUserComponent > save', this.data.mode, this.data.user);
        if (this.data.user.UserName == 'superadmin') {
            console.log('FuseEditOrViewUserComponent > save > Editando información del superadmin.');
            this.userService.editSuperAdmin(
                this.data.user.Id,
                this.data.user.FirstName,
                this.data.user.LastName,
                this.data.user.PhoneNumber,
                this.data.user.DocumentNumber,
                this.data.user.Photo).subscribe(response => {
                if (response.ResultCode == 1) {
                    // Actualizo la fecha de modificación para que se actualize la foto de perfil
                    if (this.data.user.UserName == this.authenticationService.user.UserName) {
                        console.log('FuseEditOrViewUserComponent > save > El usuario que esta logueado es el superadmin', this.data.user.UserName, this.authenticationService.user.UserName);
                        this.authenticationService.user.FirstName = this.data.user.FirstName;
                        this.authenticationService.user.LastName = this.data.user.LastName;
                        this.authenticationService.user.UpdatedDate = new Date(response.UpdatedDate);
                        this.authenticationService.user.Photo = this.data.user.Photo;
                        console.log('FuseEditOrViewUserComponent > save > this.authenticationService', this.authenticationService);

                        let authData = this.authenticationService.getAuthData();
                        authData.FirstName = this.data.user.FirstName;
                        authData.LastName = this.data.user.LastName;
                        authData.PhoneNumber = this.data.user.PhoneNumber;
                        authData.DocumentNumber = this.data.user.DocumentNumber;
                        authData.Photo = this.data.user.Photo;
                        authData.UpdatedDate = moment(this.authenticationService.user.UpdatedDate).format('YYYY-MM-DD HH:mm:ss');
                        this.authenticationService.setAuthData(authData);
                    }
                    this.dialogRef.close(this.data.user);
                    this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.user, (res) => {
                        this.sweetAlertService.success(this.translationService.success, res, null);
                    })
                } else {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    })
                }
            }, error => {
                this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            });
        } else {
            this.data.user.Roles[0] = this.roles.find(ar => ar.Id === this.data.user.Roles[0].Id);
            this.data.user.Shifts = this.shifts.filter(e => e.Checked).map(e => {
                return {Id: e.Id};
            });            this.userService.edit(
                this.data.user.Id,
                this.data.user.FirstName,
                this.data.user.LastName,
                this.data.user.PhoneNumber,
                this.data.user.DocumentNumber,
                this.data.user.Roles[0].Id,
                this.data.user.Photo,
                this.data.user.Shifts).subscribe(response => {
                if (response.ResultCode == 1) {
                    // Actualizo la fecha de modificación para que se actualize la foto de perfil
                    if (this.data.user.UserName == this.authenticationService.user.UserName) {
                        this.authenticationService.user.FirstName = this.data.user.FirstName;
                        this.authenticationService.user.LastName = this.data.user.LastName;
                        this.authenticationService.user.UpdatedDate = new Date(response.UpdatedDate);
                        this.authenticationService.user.Photo = this.data.user.Photo;

                        let authData = this.authenticationService.getAuthData();
                        authData.FirstName = this.data.user.FirstName;
                        authData.LastName = this.data.user.LastName;
                        authData.PhoneNumber = this.data.user.PhoneNumber;
                        authData.DocumentNumber = this.data.user.DocumentNumber;
                        authData.Photo = this.data.user.Photo;
                        authData.UpdatedDate = moment(this.authenticationService.user.UpdatedDate).format('YYYY-MM-DD HH:mm:ss');
                        this.authenticationService.setAuthData(authData);
                    }
                    this.dialogRef.close(this.data.user);
                    this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.user, (res) => {
                        this.sweetAlertService.success(this.translationService.success, res, null);
                    })
                } else {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    })
                }
            }, error => {
                this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            });
        }
    }

    uploadPhoto(event: any) {
        console.log('FuseAddUserComponent > uploadPhoto > event', event);
        const file = event.target.files[0];
        const maxFileSize = 1 * 1024 * 1024; // 1Mb
        console.log('FuseAddUserComponent > uploadPhoto > maxFileSize', maxFileSize);
        console.log('FuseAddUserComponent > uploadPhoto > file.zize', file.size);
        if (file.size > maxFileSize) {
            this.translationService.translate('ERRORS.MAXIMUM_SIZE_EXCEEDED', '1Mb', (res) => {
                this.sweetAlertService.error(this.translationService.success, res, null);
            })
            return;
        }
        this.blockUI.start();
        this.imageService.upload(file, this.data.user.Id, 'profile').subscribe(response => {
            console.log('FuseAddUserComponent > uploadPhoto > response', response);
            this.blockUI.stop();
            if (response.ResultCode == 1) {
                this.data.user.Photo = response.FileUri;
                this.data.user.UpdatedDate = new Date(Date.now());
                this.translationService.translate('LABELS.CORRECTLY_UPLOADED_FEMALE', this.translationService.photo, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                })
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }

    shiftRequired() {
        return this.shifts.filter(e => e.Checked).length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/users/components/edit-or-view-user/edit-or-view-user.component.ts